import styled from "styled-components";
import Link from "next/link";
import Panel from "~/shared/Panel";
import Title from "~/shared/Title";
import { formatBrazil, formatTime } from "~/utils/date";
import StatusIndicator from "~/shared/StatusIndicator";
import { getAddressFormatted } from "~/utils/address";
import { LocatedJob } from "~/types/jobs";

const LinkContainer = styled.div`
    a {
        color: ${({ theme }) => theme.color.primary.background};
        text-decoration: none;
        font-weight: bold;
    }

    a:hover {
        text-decoration: underline;
    }
`;

type JobSmallProps = {
    job: LocatedJob;
};

const JobSmall = ({ job }: JobSmallProps) => {
    return (
        <Panel>
            <div className="d-flex justify-content-between">
                <Title level="3">#{job.id}</Title>
                <StatusIndicator statusName={job.status.name} />
            </div>

            <div className="my-3">
                <p><strong>Endereço:</strong></p>
                <p>{getAddressFormatted({ addressParts: {
                    address: job?.address?.street,
                    number: job?.address?.number,
                    complement: job?.address?.complement,
                    neighborhood: job?.address?.complement,
                    cityName: job?.address?.city?.name,
                    stateAbbr: job?.address?.state?.uf,
                    zipCode: job?.address?.zipCode
                } })}</p>
            </div>

            <div className="mb-3">
                <p><strong>Data do job:</strong></p>
                {job.scheduleDate ? (
                    <>
                        <p>
                            {formatBrazil(new Date(job.scheduleDate))} -{" "}
                            {job.period === null
                                ? `${formatTime(new Date(job.scheduleDate), "HH:mm")}`
                                : job.period === "manha"
                                    ? `manhã (08:00 até às 12:00)`
                                    : job.period === "tarde"
                                        ? `tarde (12:00 até às 17:00)`
                                        : job.period === "horario_comercial"
                                            ? `horário comercial (08:00 até às 17:00)`
                                            : ``}
                        </p>
                    </>
                ) : (
                    ""
                )}
            </div>

            <LinkContainer>
                <p>
                    <Link href={`/jobs/${job.id}`}>
                        <a>Ver mais detalhes</a>
                    </Link>
                </p>
            </LinkContainer>
        </Panel>
    );
};

export default JobSmall;
